import { SettingItemEntity, SettingUnitType } from '@src/core/features/settings/entities';
import { useGetSettingsQuery } from '@src/core/features/settings/redux';

const useGetSettingByUnitType = (unitKey: SettingUnitType) => {
  const { data = { items: [] } } = useGetSettingsQuery();
  return data.items.find((item) => item.key == unitKey) ?? {} as SettingItemEntity; 
};

export default useGetSettingByUnitType;